import Controller from '@ember/controller';
import QueryParams from 'eflex/constants/bi-query-params';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { qualityReports } from 'eflex/constants/bi-report-options';
import moment from 'moment-timezone';

export default class BiQualityIndexController extends Controller {
  // jscpd:ignore-start
  @tracked drawerCollapsed = false;
  @tracked userIds = [];
  @tracked modelIds = [];
  @tracked stationIds = [];
  @tracked tags = [];
  @tracked shiftNames = [];
  @tracked beginDate = moment().startOf('day').toISOString();
  @tracked endDate = moment().endOf('day').toISOString();
  @tracked selectedToken;
  @tracked refresher = false;

  queryParams = Object.keys(QueryParams);
  selectedReport = qualityReports.qualitySummary;

  get reportOptions() {
    return Object.values(qualityReports);
  }

  @action
  onSearch(params) {
    this.resetCriteria();
    Object.assign(this, params);
  }

  @action
  resetCriteria() {
    Object.assign(this, {
      userIds: [],
      modelIds: [],
      stationIds: [],
      tags: [],
      shiftNames: [],
      beginDate: null,
      endDate: null,
    });
  }

  @action
  refresh() {
    this.refresher = true;
  }
  // jscpd:ignore-end
}
